import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
import HeroSection from "../../components/landing/HeroSection";
import SectionHeader from "../../components/landing/SectionHeader";
import FaqAccordion from "../../components/landing/FaqAccordion";

const CheckIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

const TRUST_ITEMS = [
  "Built around common Nigerian university formats.",
  "Undergraduate, MSc and PhD project documentation.",
  "One-time payment per project, no hidden fees.",
  "Private drafts that you control and edit.",
];

const FEATURES = [
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ),
    title: "Topic & title ideas",
    body: "Generate and refine project topics that match your department, project type and area of interest.",
  },
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
      </svg>
    ),
    title: "Full chapters, not just outlines",
    body: "Get introduction, literature review, methodology and more drafted in full paragraphs.",
  },
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
      </svg>
    ),
    title: "Supervisor-friendly structure",
    body: "Follows common formats used across Nigerian universities and polytechnics.",
  },
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
      </svg>
    ),
    title: "Smart editing",
    body: "Shorten, expand or regenerate sections without losing your previous drafts.",
  },
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
      </svg>
    ),
    title: "Mermaid diagrams",
    body: "Turn descriptions into sequence diagrams and flowcharts ready for your documentation.",
  },
  {
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
      </svg>
    ),
    title: "Draft history",
    body: "Track changes and keep older versions so you can always go back.",
  },
];

const STEPS = [
  {
    step: "01",
    title: "Describe your project",
    body: "Enter your course, project type, department and a short idea of the system or topic you want to build.",
  },
  {
    step: "02",
    title: "Let Astudent draft",
    body: "Get structured chapters, diagrams and key sections generated automatically in your workspace.",
  },
  {
    step: "03",
    title: "Edit & export",
    body: "Make edits, regenerate sections and export content ready to move into your final document.",
  },
];

const PERSONAS = [
  {
    title: "Final year undergraduate",
    tag: "300L · 400L · HND",
    body: "Beat short deadlines with clear, well-structured chapters that match what supervisors expect from final year projects.",
  },
  {
    title: "MSc student",
    tag: "Deeper research",
    body: "Get help expanding literature review, methodology and data analysis sections while staying focused on your core ideas.",
  },
  {
    title: "PhD candidate",
    tag: "Ambitious research",
    body: "Use Astudent as a thinking partner to explore angles, break down complex chapters and keep long documents organised.",
  },
];

const TESTIMONIALS = [
  {
    name: "Ada, 400L Computer Science",
    quote:
      "I went from scattered notes to a full draft in one weekend. My supervisor finally said, “This is structured now.”",
  },
  {
    name: "Seyi, MSc Information Systems",
    quote:
      "The literature review suggestions saved me days of reading. I still edited, but I was never starting from zero.",
  },
  {
    name: "Hauwa, HND Business Admin",
    quote:
      "Astudent helped me turn my idea into clear chapters I could confidently defend during my presentation.",
  },
];

const FAQS = [
  {
    q: "Is my project saved privately?",
    a: "Yes. Your drafts stay in your Astudent account. We do not share your content with other students.",
  },
  {
    q: "Will this work for my school's format?",
    a: "Astudent follows common structures used across Nigerian universities. You can still edit headings and sections to match your department's handbook.",
  },
  {
    q: "Do I pay per chapter or per project?",
    a: "You pay once per project documentation. That covers chapters, edits and regenerations for that project while you are working on it.",
  },
  {
    q: "Can I edit or override the AI's writing?",
    a: "Yes. You are always in control. You can edit any section, regenerate parts and move content into your final document.",
  },
  {
    q: "Is this plagiarism-free?",
    a: "Astudent generates original text for each request, but you are responsible for reviewing, citing sources properly and following your school's policies.",
  },
];

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900">
      <Navbar />

      <main className="flex-1">
        <HeroSection />

        {/* Trust strip */}
        <section
          id="highlights"
          className="border-y border-slate-200/60 bg-slate-50/50"
        >
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-8">
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {TRUST_ITEMS.map((text) => (
                <div
                  key={text}
                  className="flex items-start gap-3 rounded-xl border border-slate-200/60 bg-white px-4 py-3.5 shadow-sm"
                >
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-emerald-50 text-[#0BBF64]">
                    <CheckIcon />
                  </span>
                  <p className="text-sm leading-snug text-slate-700">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="bg-white">
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <SectionHeader
              eyebrow="Features"
              title="Everything you need to finish your documentation."
              description="From picking a solid topic to writing the final conclusion, Astudent keeps every chapter on one clean workspace."
              className="mb-12"
            />
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {FEATURES.map((item) => (
                <div
                  key={item.title}
                  className="group rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm transition hover:border-emerald-200/60 hover:shadow-soft"
                >
                  <span className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-[#0BBF64] ring-1 ring-emerald-100 transition group-hover:bg-emerald-100">
                    {item.icon}
                  </span>
                  <h3 className="mb-2 font-semibold text-slate-900">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-slate-600">
                    {item.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How it works */}
        <section id="how-it-works" className="bg-slate-50/70">
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <SectionHeader
              eyebrow="How it works"
              title="Three simple steps from idea to complete document."
              description="No long forms or confusing settings. Tell Astudent what you are working on and let the AI handle the heavy lifting."
              className="mb-12"
            />
            <div className="grid gap-6 lg:grid-cols-3">
              {STEPS.map((item, index) => (
                <div key={item.step} className="relative">
                  {index < STEPS.length - 1 && (
                    <div
                      aria-hidden
                      className="absolute top-8 left-[calc(50%+2rem)] hidden h-px w-[calc(100%-4rem)] bg-gradient-to-r from-emerald-200 to-transparent lg:block"
                    />
                  )}
                  <div className="h-full rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm">
                    <span className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#0BBF64] to-emerald-600 text-sm font-bold text-white shadow-sm shadow-emerald-500/20">
                      {item.step}
                    </span>
                    <h3 className="mb-2 font-semibold text-slate-900">
                      {item.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-slate-600">
                      {item.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Use cases */}
        <section id="use-cases" className="bg-white">
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <SectionHeader
              eyebrow="Who it's for"
              title="Designed for every stage of your academic journey."
              description="Whether you are in 400L or defending your MSc, Astudent adapts to how deep and detailed your project needs to be."
              className="mb-12"
            />
            <div className="grid gap-5 lg:grid-cols-3">
              {PERSONAS.map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-slate-200/80 bg-gradient-to-b from-white to-slate-50/50 p-6 shadow-sm"
                >
                  <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-[#0BBF64]">
                    {item.tag}
                  </p>
                  <h3 className="mb-3 font-semibold text-slate-900">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-slate-600">
                    {item.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section id="pricing" className="bg-slate-50/70">
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
              <SectionHeader
                eyebrow="Pricing"
                title="Simple pricing for one full project."
                description="Pay once to generate documentation for a single project and keep access to topic ideas and edits while you are working on it."
              />
              <div className="lg:justify-self-end w-full max-w-md">
                <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-lift">
                  <div className="h-1 bg-gradient-to-r from-[#0BBF64] via-emerald-400 to-teal-300" />
                  <div className="p-6 sm:p-8">
                    <p className="text-xs font-semibold uppercase tracking-wider text-[#0BBF64]">
                      Documentation plan
                    </p>
                    <div className="mt-3 flex items-baseline gap-2">
                      <span className="text-4xl font-extrabold tracking-tight text-slate-900">
                        &#8358;15,000
                      </span>
                      <span className="text-sm text-slate-500">
                        per project
                      </span>
                    </div>
                    <ul className="mt-6 space-y-3">
                      {[
                        "Topic ideas and edits while you work on your project.",
                        "Full documentation for one project.",
                        "Multiple regenerations and edits per chapter.",
                      ].map((text) => (
                        <li
                          key={text}
                          className="flex items-start gap-3 text-sm text-slate-700"
                        >
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-[#0BBF64]">
                            <CheckIcon />
                          </span>
                          {text}
                        </li>
                      ))}
                    </ul>
                    <a
                      href="/pricing"
                      className="mt-8 inline-flex w-full items-center justify-center rounded-xl bg-[#0BBF64] px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-emerald-500/20 transition hover:bg-[#0aa459] hover:shadow-emerald-500/30"
                    >
                      View full pricing &amp; pay
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="bg-white">
          <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <SectionHeader
              eyebrow="Testimonials"
              title="Students across Nigeria are finishing faster."
              description="Real stories from students who used Astudent to structure and complete their project documentation."
              className="mb-12"
            />
            <div className="grid gap-5 lg:grid-cols-3">
              {TESTIMONIALS.map((item) => (
                <div
                  key={item.name}
                  className="flex flex-col rounded-2xl border border-slate-200/80 bg-slate-50/50 p-6"
                >
                  <svg
                    className="mb-4 h-8 w-8 text-emerald-200"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
                  </svg>
                  <p className="flex-1 text-sm leading-relaxed text-slate-700">
                    {item.quote}
                  </p>
                  <p className="mt-4 text-xs font-semibold text-slate-500">
                    {item.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faqs" className="bg-slate-50/70">
          <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 lg:py-20">
            <SectionHeader
              eyebrow="FAQ"
              title="Frequently asked questions"
              description="Honest answers about how Astudent works for Nigerian students."
              className="mb-10"
            />
            <FaqAccordion items={FAQS} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
